export default "__VITE_ASSET__a4933c70__"